'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var pEachSeries = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(iterable, iterator) {
    var index, _iterator, _step, value, returnValue;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            index = 0;
            _iterator = _createForOfIteratorHelper(iterable);
            _context.prev = 2;

            _iterator.s();

          case 4:
            if ((_step = _iterator.n()).done) {
              _context.next = 18;
              break;
            }

            value = _step.value;
            _context.t0 = iterator;
            _context.next = 9;
            return value;

          case 9:
            _context.t1 = _context.sent;
            _context.t2 = index++;
            _context.next = 13;
            return (0, _context.t0)(_context.t1, _context.t2);

          case 13:
            returnValue = _context.sent;

            if (!(returnValue === pEachSeries.stop)) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("break", 18);

          case 16:
            _context.next = 4;
            break;

          case 18:
            _context.next = 23;
            break;

          case 20:
            _context.prev = 20;
            _context.t3 = _context["catch"](2);

            _iterator.e(_context.t3);

          case 23:
            _context.prev = 23;

            _iterator.f();

            return _context.finish(23);

          case 26:
            return _context.abrupt("return", iterable);

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 20, 23, 26]]);
  }));

  return function pEachSeries(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

pEachSeries.stop = Symbol('pEachSeries.stop');
module.exports = pEachSeries; // TODO: Remove this for the next major release

module.exports.default = pEachSeries;